import React, { Component } from "react";
//import logo from './logo.svg';
import "./material.css";
import "./App.css";
import { AnnotationAPI, LevelRecordAPI, StudentAPI } from "./api.js";
import buttonClick from "./buttonclick.wav";
import CoinDropSound from "./coin-total-up.wav";
import { Settings } from "./settings";
import { Log } from "./log.js";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import Coins from "./coins/Coins";

const api = new AnnotationAPI("/api/");
const lrApi = new LevelRecordAPI("/api/");
const studentAPI = new StudentAPI("/api/");
const log = new Log(Settings.logLevel);

let already_completed = false;
const LEVEL_COMPLETE_COINS = 500;

const annotationColors = {
  // 3, 4, and 7 are all of the ones in the first training level
  3: "#8e7cc3",
  4: "#c27ba0",
  6: "#c27ba0" /* Say it back in third training */,
  7: "#6fa8dc",
  8: "#8e7cc3" /* effective in third training */,
  9: "#c27ba0" /* ineffective in third training */,
  12: "#f8c087" /* Notes */,
  13: "#6fa8dc" /* Summary on second training level*/,
};

const steps = [
  {
    element: ".pt-app video",
    intro:
      "Welcome! Watch the video and use the buttons to mark when you notice teaching moves.",
    position: "top",
  },
  {
    element: ".pt-video-controls",
    intro:
      "Use these controls to start and stop the video. When you click the buttons below, dots will show up here to mark the spot in the video.",
    position: "top",
  },
  {
    element: ".pt-annotation-button",
    intro:
      "Click these buttons each time you notice the tutor making a teaching move",
    position: "right",
  },
  {
    element: ".pt-annotation-list",
    intro:
      "Your annotations will be marked here. If you want to write stuff down, use the notes button to type your thoughts out here.",
    position: "top",
  },
  // {
  //   element: ".pt-complete-button",
  //   intro:
  //     "When you are finished, click this button to return to the training menu.",
  //   position: "top",
  // },
];

class PTDescriptionBox extends Component {
  render() {
    return <div className="pt-description">{this.props.description}</div>;
  }
}

class PTVideo extends Component {
  constructor(props) {
    super(props);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    window.vc = this;
  }
  render() {
    return (
      <video
        ref={(v) => (this.video = v)}
        preload="auto"
        onTimeUpdate={this.onTimeUpdate}
        onSeeked={this.props.onSeeked}
      >
        Sorry, there was an error loading this video.
        <source src={this.props.url} />
      </video>
    );
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.seeking) {
      this.video.pause();
      this.video.currentTime = nextProps.playTime;
    } else if (this.video.ended) {
      this.video.pause();
    } else {
      if (nextProps.playing && this.video.paused) this.video.play();
      if (!nextProps.playing && !this.video.paused) this.video.pause();
    }
  }

  // We need to tell the app the video's length, which isn't available until now.
  componentDidMount() {
    this.props.registerVideoDuration(this.video.duration);
  }

  onTimeUpdate() {
    this.props.onTimeUpdate(this.video.currentTime);
  }
}

var scale = (d, r) => {
  return (x) => ((x - d[0]) / (d[1] - d[0])) * (r[1] - r[0]) + r[0];
};
var clamp = (min, max) => (x) => x < min ? min : x > max ? max : x;

class PTVideoTimeline extends Component {
  constructor(props) {
    super(props);
    this.padding = 20;
    const domain = [0, this.props.videoDuration],
      range = [this.padding, this.props.width - this.padding];
    this.scale = (x) => clamp(range)(scale(domain, range)(x));
    this.inverseScale = (x) => clamp(domain)(scale(range, domain)(x));
    this.barHeight = props.height / 2;
    this.state = { dragging: false };

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onClick = this.onClick.bind(this);
    this.startDragging = this.startDragging.bind(this);
    this.stopDragging = this.stopDragging.bind(this);
  }
  render() {
    return (
      <svg
        ref={(s) => (this.svg = s)}
        width={this.props.width}
        height={this.props.height}
        onMouseMove={this.onMouseMove}
        onMouseDown={this.startDragging}
        onMouseUp={this.stopDragging}
        onClick={this.onClick}
      >
        <line
          x1={this.padding}
          y1={this.barHeight}
          x2={this.props.width - this.padding}
          y2={this.barHeight}
          className="pt-play-bar"
        />
        <circle
          r="20"
          cx={this.scale(this.props.playTime)}
          cy={this.barHeight}
          className="pt-play-head"
        />
        {this.props.annotations.map((a) => (
          <PTAnnotationMarker
            key={a.id}
            cy={this.barHeight}
            cx={this.scale(a.videoTime)}
            id={a.id}
            actionNumber={a.action}
            focusedAnnotationId={this.props.focusedAnnotationId}
            onMouseOver={this.props.onMouseOverAnnotationMarker}
            onMouseOut={this.props.onMouseOverAnnotationMarker}
          />
        ))}
      </svg>
    );
  }

  startDragging(e) {
    this.setState({ dragging: true });
  }

  stopDragging(e) {
    this.setState({ dragging: false });
  }

  onMouseMove(e) {
    const x = e.clientX - this.svg.getBoundingClientRect().left;
    if (this.state.dragging) this.props.onDrag(this.inverseScale(x), true);
  }
  onClick(e) {
    const x = e.clientX - this.svg.getBoundingClientRect().left;
    this.props.onDrag(this.inverseScale(x), true);
  }
}

class PTAnnotationMarker extends Component {
  constructor(props) {
    super(props);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  render() {
    // TODO: make all actionNumbers keys in the dictionary
    let color = annotationColors[this.props.actionNumber];
    return (
      <circle
        r={this.props.id === this.props.focusedAnnotationId ? 16 : 12}
        cx={this.props.cx}
        cy={this.props.cy}
        fill={color}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
      />
    );
  }
  onMouseOver() {
    this.props.onMouseOver(this.props.id);
  }
  onMouseOut() {
    this.props.onMouseOut();
  }
}

class PTPlayButton extends Component {
  render() {
    return (
      <i className="pt-play-button material-icons" onClick={this.props.onClick}>
        {this.props.playing ? "pause_circle_filled" : "play_circle_filled"}
      </i>
    );
  }
}

class PTAnnotationButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  render() {
    let color = annotationColors[this.props.id];
    return (
      <button
        style={{ backgroundColor: color }}
        className="pt-annotation-button"
        onClick={this.onClick}
      >
        {this.props.name}
      </button>
    );
  }

  onClick() {
    this.props.onClick(this.props.id);
  }
}

class PTCompleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAnimation: false,
      isSubmitted: false,
    };
    this.onClick = this.onClick.bind(this);
    this.coinDropSound = new Audio(CoinDropSound);
  }
  render() {
    return (
      <span>
        <button
          className="pt-complete-button"
          disabled={this.state.isSubmitted}
          onClick={this.onClick}
        >
          Done
        </button>
        {this.state.showAnimation && (
          <div className="coinanimation">
            <span className="reward-text">{LEVEL_COMPLETE_COINS}+</span>
          </div>
        )}
      </span>
    );
  }
  onClick() {
    // Updates coins at the end of the level
    if (!already_completed) {
      this.setState({ showAnimation: true, isSubmitted: true });
      setTimeout(() => {
        this.coinDropSound.play();
        const coins = LEVEL_COMPLETE_COINS;
        this.props.addCoins(coins);
        studentAPI
          .post_coin(coins)
          .then((response) => response.json())
          .then((data) => setTimeout(() => (window.location = "/"), 1000));
      }, 2100);
    } else {
      window.location = "/";
    }
  }
}

class PTAnnotationList extends Component {
  render() {
    return (
      <div className="pt-annotation-list">
        {this.props.annotations.map((a) => (
          <PTAnnotationDetail
            key={a.id}
            id={a.id}
            actionNumber={a.action}
            focusedAnnotationId={this.props.focusedAnnotationId}
            editingAnnotationId={this.props.editingAnnotationId}
            onMouseOver={this.props.onMouseOverAnnotationDetail}
            onMouseOut={this.props.onMouseOverAnnotationDetail}
            onFocusTextarea={this.props.onFocusAnnotationDetailTextarea}
            onUpdateEditing={this.props.onUpdateEditingAnnotationDetail}
            onDeleteAnnotation={this.props.onDeleteAnnotation}
            name={this.getAction(a.action).name}
            comments={a.comments}
            hasComments={this.getAction(a.action).comments}
            onSaveComments={this.props.onSaveComments}
          />
        ))}
      </div>
    );
  }
  getAction(id) {
    for (let i = 0; i < this.props.actions.length; i++) {
      if (this.props.actions[i].id === id) {
        return this.props.actions[i];
      }
    }
    throw new Error("No action found with id " + id);
  }
}

class PTAnnotationDetail extends Component {
  constructor(props) {
    super(props);
    this.getClassNames = this.getClassNames.bind(this);
    this.onChangeComments = this.onChangeComments.bind(this);
    this.onSaveComments = this.onSaveComments.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onFocusTextarea = this.onFocusTextarea.bind(this);
    // We keep comments in local state until done editing to avoid
    // propagating events into global state that don't matter.
    this.state = {
      comments: this.props.comments,
    };
  }

  render() {
    return (
      <div
        className={this.getClassNames()}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onClick={this.onClick}
      >
        {this.isFocused() ? (
          <div className={`pt-annotation-focus${this.props.actionNumber}`}>
            {this.props.name}
            <i
              className="pt-annotation-delete material-icons"
              onClick={this.onClickDelete}
            >
              delete_forever
            </i>
          </div>
        ) : (
          <div
            className={`pt-annotation-detail-header${this.props.actionNumber}`}
          >
            {this.props.name}
            <i
              className="pt-annotation-delete material-icons"
              onClick={this.onClickDelete}
            >
              delete_forever
            </i>
          </div>
        )}
        {this.props.hasComments && (
          <div className="pt-annotation-comments">
            <textarea
              ref={(ta) => {
                this.textarea = ta;
              }}
              value={this.state.comments}
              // readOnly={!this.isEditing()}
              onChange={this.onChangeComments}
              onFocus={this.onFocusTextarea}
              onBlur={this.onSaveComments}
            />
          </div>
        )}
      </div>
    );
  }
  getClassNames() {
    const classNames = ["pt-annotation-detail"];
    if (this.isFocused()) classNames.push("pt-annotation-focus");
    if (this.isEditing()) classNames.push("pt-annotation-editing");
    return classNames.join(" ");
  }

  componentDidMount() {
    if (this.props.hasComments && this.textarea) {
      this.adjustTextareaHeight();
      this.textarea.focus();
    }
  }
  onClick() {
    if (this.props.hasComments && !this.props.editingAnnotationId) {
      this.props.onUpdateEditing(this.props.id);
    }
  }
  onClickDelete() {
    this.props.onDeleteAnnotation(this.props.id);
  }
  onFocusTextarea() {
    this.props.onUpdateEditing(this.props.id);
  }
  onChangeComments(e) {
    this.setState({ comments: e.currentTarget.value });
    this.adjustTextareaHeight();
  }
  onKeyupComments(e) {
    if (e.key == "enter") {
      this.props.onUpdateEditing(); // Clear global editing annotation
      this.props.onSaveComments(
        this.props.id,
        { comments: this.state.comments },
        true
      );
    }
  }
  onSaveComments(e) {
    this.props.onUpdateEditing(); // Clear global editing annotation
    this.props.onSaveComments(this.props.id, { comments: this.state.comments });
  }
  onMouseOver() {
    this.props.onMouseOver(this.props.id);
  }
  onMouseOut() {
    this.props.onMouseOut();
  }
  isFocused() {
    return this.props.id === this.props.focusedAnnotationId;
  }
  isEditing() {
    return this.props.id === this.props.editingAnnotationId;
  }
  adjustTextareaHeight() {
    this.textarea.style.height = 0; // Otherwise the scrollheight will not shrink
    this.textarea.style.height = "" + this.textarea.scrollHeight + "px";
  }
}

class PTApp extends Component {
  constructor(props) {
    super(props);
    window.app = this;
    this.state = {
      playing: false,
      seeking: false,
      annotations: this.props.annotations,
      playTime: 0,
      status: this.props.status,
      profile: null,
      stepsEnabled: true,
    };

    if (this.props.status === "complete") {
      already_completed = true;
    }

    // TODO Is this causing a race condition on the backend?
    this._ann_id = 0;
    this._ann_id = Math.max(...this.state.annotations.map((a) => a.id)) + 1;

    // Bind our callbacks.
    this.togglePlayState = this.togglePlayState.bind(this);
    this.updatePlayTime = this.updatePlayTime.bind(this);
    this.seekComplete = this.seekComplete.bind(this);
    this.registerVideoDuration = this.registerVideoDuration.bind(this);
    this.createAnnotation = this.createAnnotation.bind(this);
    this.updateAnnotation = this.updateAnnotation.bind(this);

    this.deleteAnnotation = this.deleteAnnotation.bind(this);
    this.updateFocusedAnnotation = this.updateFocusedAnnotation.bind(this);
    this.updateEditingAnnotation = this.updateEditingAnnotation.bind(this);
    this.onExit = this.onExit.bind(this);

    this.sound = new Audio(buttonClick);
  }

  componentDidMount() {
    studentAPI
      .get_profile()
      .then((response) => response.json())
      .then((res) => this.setState({ profile: res }));
  }

  render() {
    const profile = this.state.profile;
    // enabled variable from database depending on if they've had these instructions before
    // AJAX CALL to call function in views.py to update coins when necessary
    return (
      <div>
        {profile && <Coins coins={profile.coins ? profile.coins : 0} />}
        <div className="pt-app">
          <div className="top">
            <Steps
              enabled={this.props.level.id === 16 && this.state.stepsEnabled}
              steps={steps}
              initialStep={0}
              onChange={this.onChangeIntroStep}
              onExit={this.onExit}
              options={{ hideNext: false, doneLabel: "Finish" }}
            />
            <div className="left">
              <PTVideo
                registerVideoDuration={this.registerVideoDuration}
                playing={this.state.playing}
                seeking={this.state.seeking}
                onTimeUpdate={this.updatePlayTime}
                playTime={this.state.playTime}
                onSeeked={this.seekComplete}
                url={this.props.level.mediaUrl}
              />
              <div className="pt-video-controls">
                <PTPlayButton
                  playing={this.state.playing}
                  onClick={this.togglePlayState}
                />
                <PTVideoTimeline
                  width={400}
                  height={60}
                  videoDuration={this.props.level.videoDuration}
                  annotations={this.state.annotations}
                  playTime={this.state.playTime}
                  onDrag={this.updatePlayTime}
                  focusedAnnotationId={this.state.focusedAnnotationId}
                  onMouseOverAnnotationMarker={this.updateFocusedAnnotation}
                  onMouseOutAnnotationMarker={this.updateFocusedAnnotation}
                />
              </div>
            </div>
            <div className="right">
              <PTAnnotationList
                annotations={this.state.annotations}
                actions={this.props.level.actions}
                onDeleteAnnotation={this.deleteAnnotation}
                onSaveComments={this.updateAnnotation}
                focusedAnnotationId={this.state.focusedAnnotationId}
                editingAnnotationId={this.state.editingAnnotationId}
                onMouseOverAnnotationDetail={this.updateFocusedAnnotation}
                onMouseOutAnnotationDetail={this.updateFocusedAnnotation}
                onFocusAnnotationDetailTextarea={this.updateEditingAnnotation}
                onUpdateEditingAnnotationDetail={this.updateEditingAnnotation}
              />
            </div>
            <div className="clear"></div>
          </div>
          <div className="pt-annotation-buttons">
            {this.props.level.actions.map((t) => (
              <PTAnnotationButton
                key={t.id}
                id={t.id}
                name={t.name}
                onClick={this.createAnnotation}
              />
            ))}
            {this.state.status == "complete" ? (
              <PTCompleteButton
                addCoins={(newCoins) =>
                  this.setState((prev) => ({
                    profile: {
                      ...prev.profile,
                      coins: prev.profile.coins + newCoins,
                    },
                  }))
                }
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }

  onChangeIntroStep(nextStepIndex) {
    console.log("Step changed", nextStepIndex);
  }

  onExit() {
    this.setState({ stepsEnabled: false });
    console.log("Exited");
  }

  stateChangeIsWorthLogging(s1, s2) {
    if (s2.seeking) return false;
    if (s1.playState !== s2.playState) return true;
    if (s1.annotations.length !== s2.annotations.length) return true;
    for (let i = 0; i < s1.annotations.length; i++) {
      const a1 = s1.annotations[i];
      const a2 = s2.annotations[i];
      if (
        a1.id !== a2.id ||
        a1.name !== a2.name ||
        a1.videoTime !== a2.videoTime ||
        a1.comments !== a2.comments
      ) {
        return true;
      }
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    // Log when there is a previous state, and when there is a change other than playTime
    if (this.stateChangeIsWorthLogging(prevState, this.state)) {
      // Later, hit up the API.
      console.log({
        annotations: this.state.annotations,
        playTime: this.state.playTime,
        timestamp: new Date().toISOString(),
        user: "NOT SPECIFIED",
        level: "NOT SPECIFIED",
      });
    }
  }

  // This is what happens when the play/pause button is pressed.
  // Toggles the play state. The one edge case is when the video is ended;
  // in that case, if it's currently paused, we should set the playTime to 0
  // in addition to toggling.
  togglePlayState() {
    this.setState({ playing: !this.state.playing });
  }

  seekComplete() {
    this.setState({ seeking: false });
  }

  registerVideoDuration(duration) {
    this.setState({ videoDuration: duration });
  }

  // The current time of the video is part of global state because it affects
  // many components. Updates global state with playTime, whether we are seeking,
  // and any relevant status changes.
  updatePlayTime(nextPlayTime, seek) {
    let state = {
      playTime: nextPlayTime,
      videoEnded: nextPlayTime >= this.state.videoDuration,
    };
    log.debug(
      "Setting playTime to " + nextPlayTime + "; ended: " + state.videoEnded
    );
    if (seek) {
      state.seeking = true;
    }
    this.setState(state);

    if (
      this.state.status == "not_started" &&
      nextPlayTime > Settings.videoEndMargin
    ) {
      lrApi.level_started(this.props.id).then((resp) => {
        this.setState({ status: "started" });
      });
    }
    if (
      this.state.status == "started" &&
      //nextPlayTime > (this.state.videoDuration - Settings.videoEndMargin) &&
      this.state.annotations.length >= this.props.level.minAnnotations
    ) {
      lrApi.level_complete(this.props.id).then((resp) => {
        console.log("Level is complete.");
        this.setState({ status: "complete" });
      });
    }
  }

  // Globally track which annotation has focus so that we can synchronously
  // focus the annoptation marker and the annotation detail. If an annotation
  // is being edited, no focus updates have effect.
  updateFocusedAnnotation(aId) {
    if (!this.state.editingAnnotationId) {
      this.setState({ focusedAnnotationId: aId });
    }
  }

  // Globally track which annotation is being edited. When an annotation is being
  // edited, lock focus. Also, whenever editing annotation is set or cleared,
  // the same should happen with focused annotation. This addresses the edge case
  // where you finish editing an annotation after the mouse has left the annotation
  // detail element.
  updateEditingAnnotation(aId) {
    this.setState({
      editingAnnotationId: aId,
      focusedAnnotationId: aId,
    });
  }

  createAnnotation(actionId) {
    this.sound.play();

    // TODO: later Juliette change the done status; Need to check with Soren for new def
    // Check whether the level is complete.
    if (
      this.state.status == "started" &&
      //this.state.playTime > (this.props.level.videoDuration - Settings.videoEndMargin) &&
      this.state.annotations.length + 1 >= this.props.level.minAnnotations
    ) {
      lrApi.level_complete(this.props.id).then((resp) => {
        console.log("Level is complete.");
        this.setState({ status: "complete" });
      });
    }

    const action = this.getAction(actionId);
    if (action.pause) {
      this.setState({ playing: false });
    }
    let annotations = this.state.annotations.slice();
    const newAnnotation = {
      id: this.nextId(),
      timestamp: new Date().toISOString(),
      videoTime: this.state.playTime,
      comments: "",
      levelRecord: this.props.id,
      action: actionId,
    };
    api.create_annotation(newAnnotation).then((resp) => {
      resp.json().then((annotation) => {
        annotations.push(annotation);
        annotations.sort((x, y) => x.videoTime > y.videoTime);
        this.setState({ annotations: annotations });
      });
    });
  }
  updateAnnotation(id, newProps) {
    const index = this.state.annotations.findIndex((a) => a.id === id);
    const annotations = this.state.annotations;
    const updatedAnnotation = Object.assign({}, annotations[index], newProps);
    annotations[index] = updatedAnnotation;
    this.setState({ annotations: annotations });
    api.update_annotation(updatedAnnotation);
  }

  deleteAnnotation(id) {
    const index = this.state.annotations.findIndex((a) => a.id === id);
    const annotations = this.state.annotations.slice();
    const annotationToDelete = annotations[index];
    api.delete_annotation(annotationToDelete);
    annotations.splice(index, 1);
    this.setState({ annotations: annotations });
    this.updateEditingAnnotation(); // Minor race condition
  }

  getAction(id) {
    for (let i = 0; i < this.props.level.actions.length; i++) {
      if (this.props.level.actions[i].id === id) {
        return this.props.level.actions[i];
      }
    }
    throw new Error("No action found with id " + id);
  }

  nextId() {
    this._ann_id += 1;
    return this._ann_id;
  }
}

export default PTApp;



// WEBPACK FOOTER //
// ./src/App.js